export const BOARD_CADASTRO_ROUTE = '/app/customers-notificacao-cadastro';

export const BOARD_CADASTRO_LAYOUTS = {
  modal: 'modal',
  fullscreen: 'fullscreen',
  sidebar: 'sidebar',
};

export const BOARD_CADASTRO_LAYOUT_DEFAULT = BOARD_CADASTRO_LAYOUTS.modal;

const STORAGE_KEY = 'painelOs.boardCadastro.layout';

export function isBoardCadastroLayout(value) {
  return (
    value === BOARD_CADASTRO_LAYOUTS.modal ||
    value === BOARD_CADASTRO_LAYOUTS.fullscreen ||
    value === BOARD_CADASTRO_LAYOUTS.sidebar
  );
}

export function getBoardCadastroLayout() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (isBoardCadastroLayout(raw)) return raw;
  } catch {
    /* ignore */
  }
  return BOARD_CADASTRO_LAYOUT_DEFAULT;
}

export function setBoardCadastroLayout(layout) {
  const next = isBoardCadastroLayout(layout) ? layout : BOARD_CADASTRO_LAYOUT_DEFAULT;
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}
